type TUniqueId = (prefix?: string) => string;

export const uniqueRandomId: TUniqueId = (prefix = '') =>
  `${prefix}${Math.ceil(Math.random() * Number.MAX_SAFE_INTEGER).toString(36)}`;
